import { createContext, useContext, type ReactNode } from "react";
import { LEGACY_PROFILES, type ProfileInfo } from "../lib/profiles";

// The household's profiles, so a picture or a picker anywhere in the tree can look them up without
// the data being threaded through every screen. Before the first load (and for caches that predate
// editable profiles) the original two stand in.

const ProfilesContext = createContext<ProfileInfo[]>(LEGACY_PROFILES);

export const ProfilesProvider = ({ profiles, children }: { profiles?: ProfileInfo[]; children: ReactNode }) => (
  <ProfilesContext.Provider value={profiles?.length ? profiles : LEGACY_PROFILES}>{children}</ProfilesContext.Provider>
);

export const useProfiles = () => useContext(ProfilesContext);

/** Profile names in the order the household lists them. */
export const useProfileNames = () => useProfiles().map((p) => p.name);
